<div class="filter-box-container">
    <p class="mb-2" style="text-align: left;">{{ label }}</p>
    <div class="row mx-0">
        <lib-text-box class="pl-0 col-10" *ngIf="!prefixDropdownReq"
            [control]="control"
            [idName]="idName"
            [label]="label"
            [labelBlock]="false"
            [ignoreLabel]="true"
            [externalTrigger]="externalTrigger"
            [autofocus]="autofocus">
        </lib-text-box>
        <!-- lib-text-box-with-dropdown accepts either 'branch-prefixes' || 'product-prefixes' -->
        <lib-text-box-with-dropdown class="pl-0 col-10" *ngIf="prefixDropdownReq == 'branch-prefixes' || prefixDropdownReq == 'product-prefixes'"
            [control]="control"
            [idName]="idName"
            [label]="label"
            [labelBlock]="false"
            [ignoreLabel]="true"
            [externalTrigger]="externalTrigger"
            [dropdownType]="prefixDropdownReq">
        </lib-text-box-with-dropdown>
        <lib-search-button class="col-2 px-0 text-left"
            [control]="control"
            (actionEvent)="actionSearch()">
        </lib-search-button>
    </div>
</div>
